module.exports = __webpack_public_path__ + "img/rru.d27d4d3a.png";